import { useEffect, useMemo, useState } from "react";
import DirectorInformationCard from "./DirectorInformationCard";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import useSeo from "../../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import usePageVisitTracker from "../../../hooks/usePageVisitTracker";

const BoardOfDirectors = () => {
  const { getText } = useLanguageTranslation();
  const [animationClass, setAnimationClass] = useState("");
  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: directorsData = [],
    directorsError,
    isLoading: directorsIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "board_of_Directors",
    lang: languageType,
  });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(directorsData);
  }, [directorsData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });
  usePageVisitTracker();

  useEffect(() => {
    setAnimationClass("fade-in");
  }, []);

  const animationStyle = {
    animation: "fadeIn 0.5s ease-in-out",
  };

  if (directorsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        title={getText("About Us", "हमारे संबंध में")}
        titleLink="/about-us/board-of-directors"
        levelTwo={true}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div
        className={`inner-container ${animationClass}`}
        style={animationStyle}
      >
        <div className="container">
          <div className="director-section">
            <div className="container">
              <div className="row">
                {directorsIsLoading && <p>Loading...</p>}
                {directorsError && (
                  <p>Failed to load directors data. Please try again later.</p>
                )}
                {!directorsIsLoading &&
                  !directorsError &&
                  directorsData.length === 0 && (
                    <p>No directors data available.</p>
                  )}
                {directorsData.map((item, index) => (
                  <DirectorInformationCard director={item} key={index} />
                ))}
              </div>
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardOfDirectors;
